import React, {useEffect} from 'react';
import {Box, Button, Flex, Spacer, Text, Image} from '@chakra-ui/react';
import {dialog} from "../constants";

const   Header = () => {
    return (
        <Box bg="white" boxShadow="md" position={"sticky"} top={0} zIndex="10" py={1}>
            <Flex align="center" width={["90%", "80%", "70%", "60%"]} mx={"auto"} flexDirection={{base: "column", md: "row"}}>
                <Flex align="center" as="a" href="/home" _hover={{ textDecoration: "none" }}>
                    <Image src={`${process.env.PUBLIC_URL}/images/sun.jpg`} height={{base: "40px", md: "75px"}} mr={2}/>
                    <Text fontWeight="bold" fontFamily={"Caveat"} fontSize={{base: "3xl !important", md: "5xl !important"}} color={"gray.700 !important"}>
                        SolarRoots
                    </Text>
                </Flex>

              <Spacer display={{ base: "none", md: "block" }} />

              <Button
                    _hover={{bg: "green.500"}}
                    size={{base: "lg", md: "xl"}}
                    fontSize={{base: "lg", md: "2xl"}}
                    bg={"gray.700"}
                    onClick={() => {
                        dialog.open("a", {
                        title: "Get FREE Solar Quotes",
                        });
                    }}
                    px={{base: 12, md: 8}}
                >
                    Quotes
                </Button>
            </Flex>
        </Box>
    );
};

export default Header;